var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClientsList = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clients-list_svg__clip0_14166_50821)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.50156 4.11111C7.50156 5.54 6.30607 6.72222 4.80156 6.72222C3.29702 6.72222 2.10156 5.54 2.10156 4.11111C2.10156 2.68222 3.29702 1.5 4.80156 1.5C6.30607 1.5 7.50156 2.68222 7.50156 4.11111ZM4.80156 6.16667C5.94799 6.16667 6.90156 5.25955 6.90156 4.11111C6.90156 2.96267 5.94799 2.05556 4.80156 2.05556C3.65514 2.05556 2.70156 2.96267 2.70156 4.11111C2.70156 5.25955 3.65514 6.16667 4.80156 6.16667Z",
  fill: "#C9C9C9",
  stroke: "#C9C9C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 10.3333C8.5 9.61444 7.90461 9.05556 7.2 9.05556H2.4C1.69541 9.05556 1.1 9.61443 1.1 10.3333V14.5H0.5V10.3333C0.5 9.33397 1.33729 8.5 2.4 8.5H7.2C8.26275 8.5 9.1 9.33396 9.1 10.3333V14.5H8.5V10.3333Z",
  fill: "#C9C9C9",
  stroke: "#C9C9C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0031 7.22217H11.2031V8.77772H16.0031V7.22217Z",
  fill: "#C9C9C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2031 10.3333H16.0031V11.8888H11.2031V10.3333Z",
  fill: "#C9C9C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0031 4.11108H11.2031V5.66664H16.0031V4.11108Z",
  fill: "#C9C9C9"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clients-list_svg__clip0_14166_50821"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));
export default SvgClientsList;